import { TextField as MuiTextField, TextFieldProps } from '@mui/material';
import { FieldHookConfig, useField } from 'formik';
import React, { FC } from 'react';

const TextField: FC<TextFieldProps & FieldHookConfig<string>> = (props) => {
  const [field, meta] = useField(props);

  return (
    <MuiTextField
      data-testid="form.text-field"
      id={props.name}
      inputProps={{
        'data-test-id': `form.text-field.input-${props.name}`,
        ...props.inputProps,
      }}
      fullWidth
      {...field}
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error}
      InputLabelProps={{
        shrink: true,
      }}
      variant="standard"
      {...props}
    />
  );
};

export { TextField };
